module.exports = __webpack_public_path__ + "media/images/countryrect/pt-b62dde9b4c1ecbb64b9df5f8b795ba24.svg";